export default __webpack_public_path__ + "static/media/FIFA_logo.74e710fd.png";